<template>
<div>
  <h4> {{$t('leads.details.follow_up')}}</h4>
  <template :headerText="$t('leads.details.follow_up')">
    <div v-if="pursues.length">
      <div v-for="pursue in pursues" :key="pursue.id" class="cards">
        <div class="card-body">
          <h6 class="card-title"><b>{{pursue.createdAt | localTime}}<span v-if="pursue.user"> {{'leads.details.by' | translate }} {{pursue.user.name}}</span></b>
            <a v-if="pursue.user && writePermission" href="#" @click.prevent="deletePursue(pursue)">&ensp;<i class="fa fa-trash is-danger" aria-hidden="true"></i></a>
          </h6>
          <p class="card-text">
            {{ $t(getStatusById(parseInt(pursue.status.id))) }}
          </p>
          <p class="card-text observations" v-if="pursue.obs && pursue.obs.length > 0">{{pursue.obs}}</p>
        </div>
      </div>
    </div>
    <div v-else>
      {{$t('leads.details.no_regists')}}
      <br>
      <br>
    </div>
    <div v-if="writePermission" class="cards">
      <div class="card-body evollu-form">
        <h6 class="card-title is-uppercase">{{$t('leads.details.update_status')}}</h6>
        <div class="row no-gutters">
          <div class="col-12 col-md-8 col-lg-6">
            <!-- <div :class="{'col-md-12': editingStatus.id != 110, 'col-md-8': editingStatus.id == 110}"> -->
            <multiselect
              v-model="editingStatus"
              :options="statuses"
              track-by="id"
              label="name"
              :custom-label="status => $t(status.name)"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              >
            </multiselect>
          </div>
        </div>
        <div class="card-text">
          <label class="form-label">{{$t('leads.details.observations')}}</label>
          <va-input type="textarea" rows="3" :placeholder="$t('leads.details.placeholder_obs')" v-model="editingObs"></va-input>
        </div>
        <br>
        <div class="card-text" style="position: relative; min-height: 65px">
          <va-button class="pull-right" :disabled="isLoadingFromServer" @click.prevent="addRecord">{{$t('leads.details.add') }}</va-button>
        </div>
      </div>
    </div>
  </template>

    <va-modal
      size="small"
      v-model="showDeleteConfirmation"
      ref="deleteConfirmationModal"
      title=""
      :cancelText="'modal.cancel' | translate"
      :okText="'modal.confirm' | translate"
      @ok="confirmDelete">
      <div slot="header"><p style="font-size: 18px;"><b>{{'leads.modal.delete?' | translate }}</b></p></div>
      <div v-if="pursueToDelete">
        {{ $t('leads.modal.description') }} {{pursueToDelete.createdAt | localTime}}? {{ $t('leads.modal.description_2') }}
      </div>
    </va-modal>
</div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import DatePicker from '@/components/common/DatePicker'
import { mapGetters } from 'vuex'
import { Portuguese as PTLocale } from 'flatpickr/dist/l10n/pt'
import { Spanish as ESLocale } from 'flatpickr/dist/l10n/es'
import { WellbeingService } from "@/api/WellbeingService";
PTLocale.firstDayOfWeek = 1
PTLocale.rangeSeparator = ' a '

const LEADS_INFO_TYPE = 100
const READ_ACCESS_TYPE = 1
const WRITE_ACCESS_TYPE = 2
const ADMIN_ACCESS_TYPE = 3

export default {
  components: {
    Multiselect,
    DatePicker
  },
  props: [
    'pursues',
    'selectedLeadId',
    'selectedLead',
    'leadStatus',
    'service',
  ],
  computed: {
    ...mapGetters({
      statuses: 'wellbeing/statuses'
    }),
    entitiesWrite: function () {
      const filtered = this.service.user_permissions.filter(elem => elem.info_type === LEADS_INFO_TYPE && elem.access_type >= WRITE_ACCESS_TYPE)
      //if the first element is null it means that user has access to all entities
      if (filtered.length === 0) return []

      if (filtered.some(elem => elem.entity_id === null)) {
        return this.service.entities
      } else {
        const consideredEntitiesIds = filtered.map(elem => elem.entity_id)
        return this.service.entities.filter(ent => consideredEntitiesIds.includes(ent.id))
      }
    },
    currentLanguage: function () {
      return Vue.i18n.locale()
    },
    writePermission: function () {
      return this.entitiesWrite.some(ent => ent.id === parseInt(this.selectedLead.entityId))
    },
    saleDatePickerConfig: function () {
      let config = { }

      if (this.currentLanguage === 'pt') {
        config.locale = PTLocale
      } else if (this.currentLanguage === 'es') {
        config.locale = ESLocale
      } else {
        config.locale = { firstDayOfWeek: 1 }
      }

      return config
    }
  },
  data () {
    return {
      vatOptions: [{id:1, vat:6}, {id:2, vat:13}, {id:3, vat:23}],
      selectedVat: null,
      editingStatus: this.leadStatus,
      editingObs: '',
      editingSalePrice: '',
      editingSaleDate: this.moment().format('YYYY-MM-DD'),
      priceReadPermission: false,
      showDeleteConfirmation: false,
      pursueToDelete: null,
      isLoadingFromServer: false,
    }
  },
  methods: {
    getStatusById: function (id) {
      let status = this.statuses.find(status => status.id === id)
      return status ? status.name : null
    },

    addRecord: async function() {
      this.isLoadingFromServer = true
      let data = {
        obs: this.editingObs,
        statusId: this.editingStatus.id
      }

      try {
        const savedPursue = await WellbeingService.savePursue(this.selectedLeadId, data)
        this.editingObs = ''
        this.$emit('createdPursue', { 'newPursue': savedPursue })
        this.showToast(this.$t('leads.messages.add'), this.$store.state.successToastOptions)
      } catch (error) {
        console.log(error)
        this.showToast(this.$t('leads.messages.error'), this.$store.state.errorToastOptions)
      }
      setTimeout(() => {
        this.isLoadingFromServer = false
      }, 3000)
    },
    deletePursue: function (pursue) {
      this.pursueToDelete = pursue
      this.showDeleteConfirmation = true
    },
    confirmDelete: async function() {
      try {
        const deletedPursueId = await WellbeingService.deletePursue(this.pursueToDelete.id)
        this.showDeleteConfirmation = false
        this.$emit('deletedPursue', { 'pursueToDelete': this.pursueToDelete})
        this.pursueToDelete = null
        this.showToast(this.$t('leads.messages.remove'), this.$store.state.successToastOptions)
      } catch (error) {
        console.log(error)
        this.showToast(this.$t('leads.messages.error'), this.$store.state.errorToastOptions)
        this.showDeleteConfirmation = false
      }
    },
    onlyForCurrency ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)

      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 44 || this.editingSalePrice.indexOf(',') !== -1)) { // 46 is dot
        $event.preventDefault()
      }
      if (this.editingSalePrice === '' && (keyCode === 48 || keyCode === 44)) {
        $event.preventDefault()
      }
      if (this.editingSalePrice != null && this.editingSalePrice.indexOf(',') > -1 && (this.editingSalePrice.split(',')[1].length > 1)) {
        $event.preventDefault()
      }
    },
  },
  watch: {
    selectedLeadId: function (value) {
      this.editingStatus = this.statuses.find(data => data.id === parseInt(this.leadStatus))
    }
  },
  mounted () {
    this.editingStatus = this.statuses.find(data => data.id === parseInt(this.leadStatus))
  },
}
</script>

<style lang="scss">
  .sale-price {
    .input-icon {
      top: 0.55rem;
    }

    .form-group.with-icon-left input {
      padding-left: 1rem;
    }

  }

</style>
<style lang="scss" scoped>
.cards {
  margin-bottom: 1rem;
  // border: 0.5px solid #6e6e6e30;
  border: 1px solid rgba(0, 0, 0, 0.1)
}
</style>
